import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '../../assets/img/banner-campaign.svg'
import _imports_1 from '../../assets/img/campaign-image-placeholder.svg'
import _imports_2 from '../../assets/img/campaign-registered-icon.svg'
import _imports_3 from '../../assets/img/loading-dot-icon.gif'
import _imports_4 from '../../assets/img/arrow-circle-right-icon.png'


const _hoisted_1 = {
  key: 0,
  class: "campaign-section"
}
const _hoisted_2 = { class: "campaign-title-group" }
const _hoisted_3 = { class: "campaign-items" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "campaign-detail-group" }
const _hoisted_7 = { class: "campaign-detail-title" }
const _hoisted_8 = { class: "campaign-detail-sub-title" }
const _hoisted_9 = {
  key: 0,
  class: "campaign-detail-registered"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "ลงทะเบียนแล้ว", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_19 = {
  key: 1,
  class: "campaign-section"
}
const _hoisted_20 = { class: "campaign-title-group" }
const _hoisted_21 = { class: "campaign-items" }
const _hoisted_22 = { class: "campaign-detail-img" }
const _hoisted_23 = { class: "campaign-detail-group" }
const _hoisted_24 = { class: "campaign-detail-title" }
const _hoisted_25 = { class: "campaign-detail-sub-title" }

export function render(_ctx, _cache) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")
  const _component_q_skeleton = _resolveComponent("q-skeleton")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isLoading && _ctx.campaignList.length > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              class: "campaign-title-view-all",
              src: _imports_0,
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.openWebCampaign()))
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_swiper, {
              slidesPerView: 'auto',
              spaceBetween: 12,
              freeMode: true,
              modules: _ctx.modules
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaignList, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (index < 10)
                      ? (_openBlock(), _createBlock(_component_swiper_slide, {
                          key: 0,
                          class: "campaign-slide",
                          style: _normalizeStyle({ width: _ctx.campaignList.length === 1 ? '100%' : '76%' })
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "campaign-detail-img",
                              onClick: $event => (_ctx.openWebCampaign(item))
                            }, [
                              (item?.content?.th?.image_url)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: item?.content?.th?.image_url,
                                    onError: _cache[1] || (_cache[1] = (...args) => (_ctx.errorImage && _ctx.errorImage(...args)))
                                  }, null, 40, _hoisted_5))
                                : (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    src: _imports_1,
                                    onError: _cache[2] || (_cache[2] = (...args) => (_ctx.errorImage && _ctx.errorImage(...args)))
                                  }, null, 32))
                            ], 8, _hoisted_4),
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("span", null, _toDisplayString(item?.content?.th?.title), 1)
                              ]),
                              _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("span", null, _toDisplayString(item?.content?.th?.sub_title), 1),
                                (item?.is_registered)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
                                  : (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: _normalizeClass(["campaign-detail-register", { 'is-loading': _ctx.isRegisterLoading && _ctx.indexRegistering === index }]),
                                      onClick: $event => (_ctx.customerType === 'loyalty' ? _ctx.registerCampaign(item?.id, index) : _ctx.handleRedirectApp(item))
                                    }, [
                                      (_ctx.isRegisterLoading && _ctx.indexRegistering === index)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _hoisted_16))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_17, "ลงทะเบียน"))
                                    ], 10, _hoisted_13))
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["style"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256)),
                (_ctx.campaignList.length >= 2)
                  ? (_openBlock(), _createBlock(_component_swiper_slide, {
                      key: 0,
                      class: "campaign-slide-view-all",
                      onClick: _cache[3] || (_cache[3] = $event => (_ctx.openWebCampaign()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_18,
                        _createElementVNode("span", null, _toDisplayString(_ctx.textViewAll), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modules"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_q_skeleton, {
              class: "skeleton-img",
              width: "93.6vw",
              height: "10.49vh"
            })
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_swiper, {
              slidesPerView: 'auto',
              spaceBetween: 12,
              freeMode: true,
              modules: _ctx.modules
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (index) => {
                  return _createVNode(_component_swiper_slide, { class: "campaign-slide" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_q_skeleton, {
                          class: "skeleton-img",
                          width: "70.93vw",
                          height: "22.48vh"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_q_skeleton, {
                            class: "skeleton-title",
                            width: "62.4vw",
                            height: "2.39vh"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_q_skeleton, {
                            class: "skeleton-title",
                            width: "32.26vw",
                            height: "1.79vh"
                          }),
                          _createVNode(_component_q_skeleton, {
                            class: "skeleton-button",
                            width: "32.26vw",
                            height: "4.19vh"
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  })
                }), 64))
              ]),
              _: 1
            }, 8, ["modules"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}